export const works = [
  {
    id: 1,
    icon: "mdi:register-outline",
    title: "Sign Up",
    des: "Create your CryptoTX account in just a few clicks and complete our KYC process to get your account verified.",
  },
  {
    id: 2,
    icon: "et:wallet",
    title: "Send Crypto Coin",
    des: "To pay your business partners, friends, and family, simply select your USDT chain and complete the payment using your crypto wallet.",
  },
  {
    id: 3,
    icon: "iconoir:receive-dollars",
    title: "Recipient Gets Local Currency",
    des: "Your crypto is converted in transit to your recipient's local currency and delivered directly to their bank account.",
  },
];

export const frequentlyQuestions = [
  {
    id: 1,
    qus: "What is CryptoTX?",
    ans: "CryptoTX is a cutting-edge platform that allows you to send cryptocurrency, specifically USDT, directly into bank accounts worldwide, converting it instantly into the recipient’s local currency.",
  },
  {
    id: 2,
    qus: "How does CryptoTX ensure the security of transactions?",
    ans: "We prioritize the security of your funds. Our platform uses advanced encryption and complies with international monetary policies to ensure that every transaction is secure and reliably completed.",
  },
  {
    id: 3,
    qus: "Can I send USDT to any bank account in the world?",
    ans: "Yes, our global reach allows you to send USDT to virtually any bank account in the world, which will be converted into the local currency of the recipient.",
  },
  {
    id: 4,
    qus: "Are there any fees associated with sending USDT?",
    ans: "We believe in transparency. Our platform has a straightforward fee structure with no hidden costs. The fees are clearly stated before you confirm any transaction.",
  },
  {
    id: 5,
    qus: "How long does it take for the recipient to receive funds in their local currency?",
    ans: "Speed is key at CryptoTX. Once you send USDT to our platform, the recipient’s bank account is credited with the local currency typically within 24hrs, depending on the local bank processing times.",
  },
];

export const landingHeaders = [
  {
    id: 1,
    name: "Home",
    url: "/",
  },
  {
    id: 2,
    name: "Login",
    url: import.meta.env.VITE_APP_BACKEND_URL + "/login",
  },
  {
    id: 3,
    name: "Register",
    url: import.meta.env.VITE_APP_BACKEND_URL + "/register",
  },
];
